import { Component, OnInit, Injectable, Input } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material";
import { Globales } from "../../../Global";
import { Perfil } from "src/app/Models/Menu/menu";

@Injectable()
@Component({
  selector: "app-home",
  templateUrl: "../Home/home.component.html",
  styleUrls: ["../Home/home.component.css"]
})
export class HomeComponent implements OnInit{
  @Input() item: Perfil;
  animal: string;
  name: string;
  valores: any[] = [];
  subMenu: any[] = [];
  results: Perfil;

  nombre: string;
  apellido: string;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    public globals: Globales
  ) {
    if (parseInt(sessionStorage.getItem("usuarioID"), 10) > 0) {
      this.inicio();
      this.globals.isShowing = true;
      sessionStorage.setItem("clienteID", "0");

      this.nombre = sessionStorage.getItem("Nombre");
      this.apellido = sessionStorage.getItem("Apellido");
    } else {
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit() {
    this.router.navigate(["/home/Menu_Logo"]);
  }

  MostrarDatos(acepta: boolean) {
    console.log(acepta);
  }

  EntrarCliente = () => {};

  logout() {
    sessionStorage.clear();
    this.router.navigate(["/login"]);
  }

  LoginSet() {
    this.router.navigate(["/home"]);
  }

  cambio() {
    this.router.navigate(["/home/cambio"]);
  }

  inicio(){
    this.router.navigate(["/home/Menu_Logo"]);
  }

  toggleSidenav() {
    this.globals.isShowing = !this.globals.isShowing;
  }

  callMethods() {
    this.toggleSidenav();
  }
}
